'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPlug = function TiPlug(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 29.2c-6.4 0-11.7-5.3-11.7-11.7h3.4c0 4.6 3.7 8.3 8.3 8.3s8.3-3.7 8.3-8.3h3.4c0 6.4-5.3 11.7-11.7 11.7z m10-9.2c-0.9 0-1.7-0.7-1.7-1.7v-5h-16.6v5c0 1-0.8 1.7-1.7 1.7s-1.7-0.7-1.7-1.7v-6.6c0-1 0.8-1.7 1.7-1.7h20c0.9 0 1.7 0.7 1.7 1.7v6.6c0 1-0.8 1.7-1.7 1.7z m-13.3-15v5h-3.4v-5h3.4z m0-1.7h-3.4c-0.9 0-1.6 0.8-1.6 1.7v5c0 0.9 0.7 1.7 1.6 1.7h3.4c0.9 0 1.6-0.8 1.6-1.7v-5c0-0.9-0.7-1.7-1.6-1.7z m5 25.9v4.1h-3.4v-4.1h3.4z m0-3.4h-3.4c-1.8 0-3.3 1.5-3.3 3.4v4.1c0 1.9 1.5 3.4 3.3 3.4h3.4c1.8 0 3.3-1.5 3.3-3.4v-4.1c0-1.9-1.5-3.4-3.3-3.4z m5-20.8v5h-3.4v-5h3.4z m0-1.7h-3.4c-0.9 0-1.6 0.8-1.6 1.7v5c0 0.9 0.7 1.7 1.6 1.7h3.4c0.9 0 1.6-0.8 1.6-1.7v-5c0-0.9-0.7-1.7-1.6-1.7z m3.3 16.7h-20c-0.5 0-0.8-0.4-0.8-0.8s0.3-0.9 0.8-0.9h20c0.5 0 0.8 0.4 0.8 0.9s-0.3 0.8-0.8 0.8z m-10 7.5c-0.6 0-1.1-0.1-1.7-0.2v2.7h3.4v-2.7c-0.6 0.1-1.1 0.2-1.7 0.2z m-5-0.8h1.7v3.3h-1.7v-3.3z m8.3 0h1.7v3.3h-1.7v-3.3z' })
        )
    );
};

exports.default = TiPlug;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/plug.js
// module id = 3924
// module chunks = 0